module.exports = __webpack_public_path__ + "static/media/no-result.5c356c51.svg";